module.exports = __webpack_public_path__ + "static/media/eng_d_2247.f49250fd.vtt";